import { AnyAri } from '@atlassian/ari/any-ari';
import { proxy } from 'valtio';

import { Deferrable } from '@canvas/deferrable';
import {
  type FrameContext,
  type FrameState,
  type FrameToken,
} from '@canvas/frame-api-types';
// eslint-disable-next-line no-restricted-imports
import { tokenManager } from '@canvas/token-manager';

const emptyState: FrameState = {
  container: '',
  board: '',
  accessToken: '',
  mediaToken: '',
  mediaBaseUrl: '',
  mediaCollectionId: '',
  dataSecurityPolicy: undefined,
};

export const currentHostFrameContext = proxy<FrameContext>({
  data: emptyState,
});

// frameContextReady resolves when updateFrameContext() is first called
// await frameContextReady.get() if there's a chance that currentHostFrameContext may not be set yet
const frameContextReady = new Deferrable<FrameContext>();

export const updateFrameContext = (token: FrameToken | undefined) => {
  currentHostFrameContext.data.container = token?.container ?? '';
  currentHostFrameContext.data.board = token?.board ?? '';
  currentHostFrameContext.data.accessToken = token?.accessToken ?? '';
  currentHostFrameContext.data.mediaToken = token?.mediaToken ?? '';
  currentHostFrameContext.data.mediaBaseUrl = token?.mediaBaseUrl ?? '';
  currentHostFrameContext.data.mediaCollectionId = token?.mediaCollectionId ?? '';
  currentHostFrameContext.data.editionOnlyUseForAnalytics =
    token?.editionOnlyUseForAnalytics;
  currentHostFrameContext.data.dataSecurityPolicy = token?.dataSecurityPolicy;

  if (!isEmptyToken(token)) {
    tokenManager.updateToken(token);
  }

  frameContextReady.resolve(currentHostFrameContext);
};

const isEmptyToken = (token: FrameToken | undefined) => {
  return tokenManager.isEmpty(token);
};

export type AccessTokenBody = {
  token: string;
};

export type MediaTokenBody = {
  token: string;
  baseUrl: string;
  contentId: string;
};

export const getFrameContextReferenceId = () => {
  try {
    const ari = AnyAri.parse(currentHostFrameContext.data.board);
    return ari.resourceId;
  } catch {
    return undefined;
  }
};
